// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"353":"0dde87f93f086749","837":"74a494a8dc3b317a","905":"a7f4bde9e8c5f207"}[chunkId] + ".js";
};